const homeCn = {
  hero: {
    title: '欢迎来到乡村集市',
    subtitle: '找到您需要的一切',
  },
  search: {
    placeholderDefault: '搜索产品...',
    typewriterPlaceholders: ['查克科伊尔集市', '综合商店', '阿利姆商店', '马齿苋'],
  },
  partners: {
    heading: '我们的合作伙伴',
    subheading: '与值得信赖的组织合作',
  },
};

export default homeCn;
